import { Grid } from '@material-ui/core';
import { connect } from 'formik';
import React from 'react';
import createShowIf from 'v2/components/Shared/createShowIf';

import type { IForm } from 'v2/components/Shared/Content';

import { EChargeType } from '../../classes/Product';

import type { Payments } from '../../classes/Payment';

interface IProps extends IForm<Payments> {}

const Free = (props: Partial<IProps>) => {
  const { values } = props.formik;
  const ShowIfPayments = createShowIf<Payments>();

  return (
    <ShowIfPayments value={values} compare={{ eq: { charge_type: EChargeType.FREE } }}>
      <Grid item xs={12}>
        <div
          style={{
            width: '100%',
            height: '200px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            maxWidth: '600px',
            margin: '0 auto',
          }}
        >
          <div>
            <img src='/img/eduzzinho-thumbsup.png' alt='Eduzzinho' width='100px' style={{ marginRight: '50px' }} />
          </div>

          <div>
            <b>Eba! Produto gratuito.</b>
            <p>Produto gratuito é uma ótima maneira de captar leads, você pode utilizar como produto de entrada para outro produto pago.</p>
          </div>
        </div>
      </Grid>
    </ShowIfPayments>
  );
};

export default connect(Free);
